import { tKey } from 'ember-intl';
import type { BeniSmartCompsetCategory } from 'lumen/models';

export const BENI_SMART_COMPSET_CATEGORIES = {
  BASE_RATE: 'base_rate',
  CITY_CENTRE: 'city_centre',
  HOTEL_CLASS: 'hotel_class',
  LAT_LONG: 'lat_long',
  REVIEW: 'review',
  ROOMS: 'rooms',
  STARS: 'stars',
  AMENITIES: 'amenities',
  AIRPORT: 'airport',
  ACCOMMODATION_TYPE: 'accommodation_type',
} as const;
export type SmartCompsetCategory =
  (typeof BENI_SMART_COMPSET_CATEGORIES)[keyof typeof BENI_SMART_COMPSET_CATEGORIES];

export const BENI_SMART_COMPSET_CATEGORY_TRANSLATIONS = {
  [BENI_SMART_COMPSET_CATEGORIES.LAT_LONG]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.lat_long',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.REVIEW]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.review',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.BASE_RATE]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.base_rate',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.ROOMS]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.rooms',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.CITY_CENTRE]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.city_centre',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.STARS]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.stars',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.HOTEL_CLASS]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.hotel_class',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.AMENITIES]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.amenities',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.AIRPORT]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.airport',
  ),
  [BENI_SMART_COMPSET_CATEGORIES.ACCOMMODATION_TYPE]: tKey(
    'benchmark_insight.settings.competitors.smart_compset.accommodation_type',
  ),
} as const;

export const BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS = {
  1: tKey(
    'benchmark_insight.settings.competitors.smart_compset.weights.value.1',
  ), // A little bit
  2: tKey(
    'benchmark_insight.settings.competitors.smart_compset.weights.value.2',
  ), // Somewhat
  3: tKey(
    'benchmark_insight.settings.competitors.smart_compset.weights.value.3',
  ), // Moderate,
  4: tKey(
    'benchmark_insight.settings.competitors.smart_compset.weights.value.4',
  ), // Quite a bit,
  5: tKey(
    'benchmark_insight.settings.competitors.smart_compset.weights.value.5',
  ), // A lot,
} as const;

export type SmartCompsetCategoryWeight = 1 | 2 | 3 | 4 | 5;

export interface BeniSmartCompsetCategoryWithWeight extends BeniSmartCompsetCategory {
  weight: SmartCompsetCategoryWeight;
}

export const BENI_SMART_COMPSET_ACTIONS = {
  UPDATE: 'update',
};
export type BeniSmartCompsetAction =
  (typeof BENI_SMART_COMPSET_ACTIONS)[keyof typeof BENI_SMART_COMPSET_ACTIONS];
